export function cadastroCondutorInRequest(params = {}) {
  return {
    type: '@cadastrocondutor/CADASTROCONDUTOR_IN_REQUEST',
    payload: { params },
  };
}



export function findCadastroCondutor(cond_cpf) {
  return {
    type: '@cadastrocondutor/FIND_CADASTROCONDUTOR',
    payload: { cond_cpf },
  };
}

export function failedRequest() {
  return {
    type: '@cadastrocondutor/FAILED_REQUEST',
  };
}

export function deleteCadastroCondutor(cond_cpf, params) {
  return {
    type: '@cadastrocondutor/DELETE_CADASTROCONDUTOR',
    payload: { cond_cpf, params },
  };
}

export function updateCadastroCondutor(cadastrocondutor, params) {
  return {
    type: '@cadastrocondutor/UPDATE_CADASTROCONDUTOR',
    payload: { cadastrocondutor, params },
  };
}

export function storeCadastroCondutor(cadastrocondutor, params) {
  return {
    type: '@cadastrocondutor/STORE_CADASTROCONDUTOR',
    payload: { cadastrocondutor, params },
  };
}

export function successInRequest(
  cadastrocondutor,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastrocondutor/SUCCESS_IN_REQUEST',
    payload: { cadastrocondutor, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(cadastrocondutor) {
  return {
    type: '@cadastrocondutor/SUCCESS_REQUEST',
    payload: { cadastrocondutor },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastrocondutor/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastrocondutor/RECORD_FILTERING',
    payload: { params },
  };
}
